import type { StoryModel } from 'types/story';
import { prependUrlProtocol } from 'utils/url/prepend-url-protocol';
import { IMAGE_PARAMS, replaceUrlHostname } from 'utils/assets';

/** Adds the image's natural size to its URL search params */
export function setImageSize(src: string, storycardsDomain: StoryModel['storycardsDomain']) {
	return new Promise<string>(res => {
		const img = new Image();
		img.onload = () => {
			const url = new URL(prependUrlProtocol(src, 'https'));
			url.searchParams.set(IMAGE_PARAMS.oW, img.width.toString());
			url.searchParams.set(IMAGE_PARAMS.oH, img.height.toString());
			res(url.href);
		};
		img.src = replaceUrlHostname(src, storycardsDomain);
	});
}
